import { Children } from "react"
import { theme } from "../../../../utils/theme/godzilla_light"
import { Box, Typography, useMediaQuery } from "@mui/material"
import { PageSection } from "../../components"
import { useTranslation } from "react-i18next"
import EssentialImage1 from '../../../../assets/images/svgs/collaboratingCollegues/essential_01.svg'
import EssentialImage2 from '../../../../assets/images/svgs/collaboratingCollegues/essential_02.svg'
import EssentialImage3 from '../../../../assets/images/svgs/collaboratingCollegues/essential_03.svg'
import TransMsg from './transMessage'

const styles = {
    itemCardBox:{
        ...theme.components.shadowCard, 
        p: "33px 18px 33px 18px", 
        maxWidth: "343px",
         width: "100%" 
    },
    itemDesc:{
        ...theme.typography.components.sectionDescription, 
        fontSize: "16.45px", 
        color: "#393939", 
        mt: "9px", 
        lineHeight: "27px"
    }
}

const ImageList = () => {
    const isMobileX = useMediaQuery(theme.breakpoints.down(700))

    const imageListData = [
        {
            imageUrl: EssentialImage1,
            description: "WHO: Identify which patients to refer and when in their course of disease to discuss treatment"
        },
        {
            imageUrl: EssentialImage2,
            description: "WHAT: Assess baseline images and functional changes"
        },
        {
            imageUrl: EssentialImage3,
            description: "WHEN: Determine appropriate follow-up and patient management"
        }
    ]

    return (
        <Box mt={"38px"} display={"flex"} gap={"12px"} flexWrap={"wrap"} px={"31px"} justifyContent={"center"}>
            {Children.toArray(imageListData.map((item) => {
                return (
                    <Box flex={isMobileX ? "none" : 1} sx={styles.itemCardBox} >
                        <Box sx={{ height: "145px" ,maxWidth: "343px"}}>
                            <img src={item.imageUrl} style={{ maxWidth: "343px" }} alt="collab-img" />
                        </Box>
                        <Typography sx={styles.itemDesc}>
                            {item.description}
                        </Typography>
                    </Box>
                )
            }))}
        </Box>
    )
}

const PartnershipEssential = () => {
    const { t } = useTranslation()
    return (
        <PageSection
            title={t(TransMsg.PARTNERSHIP_IS_ESSENTIAL)}
            description={t(TransMsg.PARTNERSHIP_IS_ESSENTIAL_DESCRIPTION)}
            sectionTitle={t(TransMsg.PARTNERSHIP_IS_ESSENTIAL_SUB_TITLE)}
            descriptionSx={{ mt: "38px" }}
            subTitleSx={{ mt: "38px", fontWeight:400 }}
            customElement={<ImageList />}
        />
    )
}

export default PartnershipEssential